//Coming Soon
import React from 'react';

function Blog(){
    return(
        <section id="">
       
        </section>
    );
}

export default Blog;